import { useEffect, useState, MouseEvent, JSX } from "react";
import ProfileModal from "./profileModal";
import {
  Avatar,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import {
  DarkModeOutlined,
  LightModeOutlined,
  Logout,
  PersonOutlined,
  SettingsOutlined,
} from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { Socket } from "socket.io-client";

interface ProfileProps {
  socket: Socket | null; // Substitua `any` pelo tipo correto do socket, se disponível
  colorMode: boolean;
  setColorMode: React.Dispatch<React.SetStateAction<boolean>>;
  administrador: boolean;
}

export default function Profile({
  socket,
  colorMode,
  setColorMode,
  administrador,
}: ProfileProps): JSX.Element {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [baseImage, setBaseImage] = useState<string>("");
  const theme = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    const resultPerfil = localStorage.getItem("perfil");
    if (resultPerfil) {
      const parsedPerfil = JSON.parse(resultPerfil);
      setBaseImage(parsedPerfil.foto);
    }
  }, [localStorage.getItem("perfil")]);

  const handlePerfil = (): void => {
    setOpenModal(true);
    handleClose();
  };

  const handleLogout = (): void => {
    socket?.disconnect();
    localStorage.clear();
    navigate("/login");
  };

  const handleClick = (event: MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleConfig = (): void => {
    navigate("configuracoes");
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="Abrir Opções">
        <IconButton onClick={handleClick}>
          <Avatar src={baseImage} />
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock={true}
        sx={{ marginLeft: "-5px" }}
      >
        <MenuItem onClick={handlePerfil}>
          <ListItemIcon>
            <PersonOutlined />
          </ListItemIcon>
          <ListItemText>Perfil</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setColorMode((prev) => {
              localStorage.setItem(
                "theme",
                JSON.stringify({ colorMode: !prev })
              );
              return !prev;
            });
          }}
          disabled={false}
        >
          <ListItemIcon>
            {!colorMode ? <DarkModeOutlined /> : <LightModeOutlined />}
          </ListItemIcon>
          <ListItemText>
            {!colorMode ? "Modo Noturno" : "Modo Claro"}
          </ListItemText>
        </MenuItem>
        {administrador && (
          <MenuItem onClick={handleConfig}>
            <ListItemIcon>
              <SettingsOutlined />
            </ListItemIcon>
            <ListItemText>Configurações</ListItemText>
          </MenuItem>
        )}
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout />
          </ListItemIcon>
          <ListItemText>Sair</ListItemText>
        </MenuItem>
      </Menu>
      <ProfileModal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
}
